import { render, staticRenderFns } from "./EditarEscalas.vue?vue&type=template&id=6925c23c"
import script from "./EditarEscalas.vue?vue&type=script&lang=js"
export * from "./EditarEscalas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports